import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const ExitIcon = (props: any) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M13.3333333 15.5555556L20 10l-6.6666667-5.55555555V8H5.55555555v4h7.77777775v3.5555556zM2.5 17.5v-15h8.6111111V0H2.22222222C1 0 0 1 0 2.22222222V17.7777778C0 19 1 20 2.22222222 20h8.88888888v-2.5H2.5z" />
    </SvgIcon>
  );
};

export default ExitIcon;
